import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@tsin-env/environment';

export interface IAttendanceReq {
  applicationId: string;
  administrationId: string;
  attendance: 'Present' | 'Absent' | 'AWOL';
}

const ATTENDANCE_URL = `${environment.apiUrl}/attendances`;

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  constructor(private http: HttpClient) { }

  getAttendanceByAdministration(administrationId: string): Observable<any> {
    return this.http.get<any>(`${ATTENDANCE_URL}/administration/${administrationId}`);
  }

  getByApplicationId(applicationId: string): Observable<any> {
    return this.http.get<any>(`${ATTENDANCE_URL}/application/${applicationId}`);
  }

  markAttendance(attendance: IAttendanceReq): Observable<any> {
    return this.http.post<any>(`${ATTENDANCE_URL}/mark-attendance`, attendance);
  }
}
